import { TableColumnMeta } from "ds/components/Table/types";

export enum MIGRATION_QUEUE_COLUMN_ID {
  STATE = "STATE",
  STACK = "STACK",
  LAST_UPDATE = "LAST_UPDATE",
  NOTE = "NOTE",
}

const MAX_CELL_WIDTH = 1200;

export const MIGRATION_QUEUE_TABLE_COLUMNS_CONFIG: Record<
  MIGRATION_QUEUE_COLUMN_ID,
  TableColumnMeta
> = {
  [MIGRATION_QUEUE_COLUMN_ID.STATE]: {
    id: MIGRATION_QUEUE_COLUMN_ID.STATE,
    title: "Migration state",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: 260,
    resizable: true,
    allowsSorting: false,
    canHide: false,
    configurable: true,
  },
  [MIGRATION_QUEUE_COLUMN_ID.STACK]: {
    id: MIGRATION_QUEUE_COLUMN_ID.STACK,
    title: "Stack",
    minWidth: 150,
    defaultWidth: 400,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: false,
    configurable: true,
  },
  [MIGRATION_QUEUE_COLUMN_ID.LAST_UPDATE]: {
    id: MIGRATION_QUEUE_COLUMN_ID.LAST_UPDATE,
    title: "Last update",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: 240,
    resizable: true,
    allowsSorting: true,
    canHide: false,
    configurable: true,
  },
  [MIGRATION_QUEUE_COLUMN_ID.NOTE]: {
    id: MIGRATION_QUEUE_COLUMN_ID.NOTE,
    title: "Note",
    minWidth: 150,
    defaultWidth: 280,
    maxWidth: 480,
    resizable: true,
    allowsSorting: false,
    canHide: false,
    configurable: true,
  },
};

export const MIGRATION_QUEUE_SORT_CONFIG: Partial<Record<MIGRATION_QUEUE_COLUMN_ID, string>> = {
  [MIGRATION_QUEUE_COLUMN_ID.LAST_UPDATE]: "updatedAt",
};
